import axios from 'axios';
import config from '../../config';
const baseUrl = config.baseUrl;
const endpoint1 = '/api/encuestas-alimentacion';
const endpoint2 = '/api/procesar-encuestasEDAH';
export const getEncuestasAlimentacion = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint1}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las encuestas:', error);
    throw error;
  }
};

/**
 * Procesa las encuestas de alimentación (inserta, guarda detalle y actualiza estado).
 */
export const procesarEncuestasEDAH = async () => {
  try {
    const response = await axios.post(`${baseUrl}${endpoint2}`);
    return response.data;
  } catch (error) {
    console.error('Error al procesar encuestas:', error);
    throw error;
  }
};
